// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Phone list view of ResponsiveTable: one card per row.
   head: [avatar] title/subtitle [badges] [row menu]
   body: two-column field grid (label over value)
   foot: row actions
   ============================================================ */

.rt-cards__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rt-card {
  position: relative;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  box-shadow: var(--ds-shadow-xs);
  padding: 14px var(--ds-space-4);
  transition:
    transform 0.12s var(--ds-ease),
    background-color 0.12s;
}

.rt-card--clickable {
  cursor: pointer;
}

.rt-card--clickable:active {
  background: var(--ds-surface-2);
  transform: scale(0.99);
}

/* ── Head ── */
.rt-card__head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-3);
  min-width: 0;
}

.rt-card__heading {
  flex: 1 1 auto;
  min-width: 0;
}

.rt-card__title {
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.35;
  color: var(--ds-heading);
  overflow-wrap: anywhere;
}

.rt-card__title a {
  color: inherit;
}

.rt-card__subtitle {
  margin-top: 2px;
  font-size: 0.85rem;
  color: var(--ds-text-2);
  overflow-wrap: anywhere;
}

.rt-card__badges {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  max-width: 45%;
}

.rt-card__badges .ant-tag {
  margin-inline-end: 0;
}

.rt-card__avatar {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.rt-card__avatar--0 {
  background: #dff1f7;
  color: #0e6580;
}
.rt-card__avatar--1 {
  background: #e4e9f5;
  color: #334a8a;
}
.rt-card__avatar--2 {
  background: #e3f3ea;
  color: #1c6b45;
}
.rt-card__avatar--3 {
  background: #fbeede;
  color: #8a5a12;
}
.rt-card__avatar--4 {
  background: #efe6f6;
  color: #5d3a86;
}
.rt-card__avatar--5 {
  background: #e7edf1;
  color: #334a60;
}

.rt-card__chevron {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  margin-inline: 4px 2px;
  border-top: 2px solid var(--ds-text-muted);
  border-inline-end: 2px solid var(--ds-text-muted);
  transform: rotate(45deg);
}

[dir="rtl"] .rt-card__chevron {
  transform: rotate(-45deg);
}

/* ── Fields ── */
.rt-card__fields {
  margin: 12px 0 0;
  padding-top: 12px;
  border-top: 1px dashed var(--ds-border-soft);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-flow: row dense;
  gap: 10px 16px;
}

.rt-card__field {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.rt-card__field--full {
  grid-column: 1 / -1;
}

.rt-card__field dt {
  color: var(--ds-text-2);
  font-weight: 500;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  overflow-wrap: anywhere;
}

.rt-card__field dd {
  margin: 0;
  color: var(--ds-text);
  font-size: 0.9rem;
  min-width: 0;
  overflow-wrap: anywhere;
}

/* Values carry dir="auto" so numbers, emails and Latin names aren't reordered inside an
   RTL card; keep them aligned with the card's own direction regardless. */
[dir="rtl"] .rt-card__field dd {
  text-align: right;
}

.rt-card__field--end dd {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

/* ── Actions ── */
.rt-card__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: var(--ds-space-1);
  margin: 12px calc(var(--ds-space-2) * -1) -6px;
  padding-top: 6px;
  border-top: 1px solid var(--ds-border-soft);
}

.rt-card__actions .ant-btn {
  min-height: 40px;
}

.rt-card__actions .ant-btn-link,
.rt-card__actions .ant-btn-text {
  color: var(--ds-text-2);
}

/* A lone row menu (⋯) sits in the card's top-end corner instead of a footer. */
.rt-card__actions:has(.row-actions-trigger):not(:has(.ant-btn, a[href], input)) {
  position: absolute;
  top: 8px;
  inset-inline-end: 6px;
  margin: 0;
  padding: 0;
  border: 0;
}

.rt-card:has(> .rt-card__actions .row-actions-trigger):not(:has(> .rt-card__actions .ant-btn))
  > .rt-card__head {
  padding-inline-end: 36px;
}

/* ── States & pagination ── */
.rt-cards__empty {
  padding: var(--ds-space-8) 0;
  background: var(--ds-surface);
  border: 1px dashed var(--ds-border);
  border-radius: var(--ds-radius-lg);
}

.rt-cards__title,
.rt-cards__footer {
  margin-bottom: var(--ds-space-3);
}

.rt-cards__footer {
  margin-top: var(--ds-space-4);
}

.rt-cards__pagination {
  display: flex;
  justify-content: center;
  margin-top: var(--ds-space-4);
}
`, "",{"version":3,"sources":["webpack://./src/design-system/ResponsiveTable.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B;;0BAEwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,0CAA0C;EAC1C,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,aAAa;EACb,gDAAgD;EAChD,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;0EAC0E;AAC1E;EACE,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":["/* ============================================================\n   Phone list view of ResponsiveTable: one card per row.\n   head: [avatar] title/subtitle [badges] [row menu]\n   body: two-column field grid (label over value)\n   foot: row actions\n   ============================================================ */\n\n.rt-cards__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rt-card {\n  position: relative;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  box-shadow: var(--ds-shadow-xs);\n  padding: 14px var(--ds-space-4);\n  transition:\n    transform 0.12s var(--ds-ease),\n    background-color 0.12s;\n}\n\n.rt-card--clickable {\n  cursor: pointer;\n}\n\n.rt-card--clickable:active {\n  background: var(--ds-surface-2);\n  transform: scale(0.99);\n}\n\n/* ── Head ── */\n.rt-card__head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n  min-width: 0;\n}\n\n.rt-card__heading {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rt-card__title {\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 1.35;\n  color: var(--ds-heading);\n  overflow-wrap: anywhere;\n}\n\n.rt-card__title a {\n  color: inherit;\n}\n\n.rt-card__subtitle {\n  margin-top: 2px;\n  font-size: 0.85rem;\n  color: var(--ds-text-2);\n  overflow-wrap: anywhere;\n}\n\n.rt-card__badges {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 4px;\n  max-width: 45%;\n}\n\n.rt-card__badges .ant-tag {\n  margin-inline-end: 0;\n}\n\n.rt-card__avatar {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.rt-card__avatar--0 {\n  background: #dff1f7;\n  color: #0e6580;\n}\n.rt-card__avatar--1 {\n  background: #e4e9f5;\n  color: #334a8a;\n}\n.rt-card__avatar--2 {\n  background: #e3f3ea;\n  color: #1c6b45;\n}\n.rt-card__avatar--3 {\n  background: #fbeede;\n  color: #8a5a12;\n}\n.rt-card__avatar--4 {\n  background: #efe6f6;\n  color: #5d3a86;\n}\n.rt-card__avatar--5 {\n  background: #e7edf1;\n  color: #334a60;\n}\n\n.rt-card__chevron {\n  flex: 0 0 auto;\n  width: 8px;\n  height: 8px;\n  margin-inline: 4px 2px;\n  border-top: 2px solid var(--ds-text-muted);\n  border-inline-end: 2px solid var(--ds-text-muted);\n  transform: rotate(45deg);\n}\n\n[dir=\"rtl\"] .rt-card__chevron {\n  transform: rotate(-45deg);\n}\n\n/* ── Fields ── */\n.rt-card__fields {\n  margin: 12px 0 0;\n  padding-top: 12px;\n  border-top: 1px dashed var(--ds-border-soft);\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  grid-auto-flow: row dense;\n  gap: 10px 16px;\n}\n\n.rt-card__field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.rt-card__field--full {\n  grid-column: 1 / -1;\n}\n\n.rt-card__field dt {\n  color: var(--ds-text-2);\n  font-weight: 500;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  overflow-wrap: anywhere;\n}\n\n.rt-card__field dd {\n  margin: 0;\n  color: var(--ds-text);\n  font-size: 0.9rem;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n/* Values carry dir=\"auto\" so numbers, emails and Latin names aren't reordered inside an\n   RTL card; keep them aligned with the card's own direction regardless. */\n[dir=\"rtl\"] .rt-card__field dd {\n  text-align: right;\n}\n\n.rt-card__field--end dd {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n}\n\n/* ── Actions ── */\n.rt-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  align-items: center;\n  gap: var(--ds-space-1);\n  margin: 12px calc(var(--ds-space-2) * -1) -6px;\n  padding-top: 6px;\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n.rt-card__actions .ant-btn {\n  min-height: 40px;\n}\n\n.rt-card__actions .ant-btn-link,\n.rt-card__actions .ant-btn-text {\n  color: var(--ds-text-2);\n}\n\n/* A lone row menu (⋯) sits in the card's top-end corner instead of a footer. */\n.rt-card__actions:has(.row-actions-trigger):not(:has(.ant-btn, a[href], input)) {\n  position: absolute;\n  top: 8px;\n  inset-inline-end: 6px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.rt-card:has(> .rt-card__actions .row-actions-trigger):not(:has(> .rt-card__actions .ant-btn))\n  > .rt-card__head {\n  padding-inline-end: 36px;\n}\n\n/* ── States & pagination ── */\n.rt-cards__empty {\n  padding: var(--ds-space-8) 0;\n  background: var(--ds-surface);\n  border: 1px dashed var(--ds-border);\n  border-radius: var(--ds-radius-lg);\n}\n\n.rt-cards__title,\n.rt-cards__footer {\n  margin-bottom: var(--ds-space-3);\n}\n\n.rt-cards__footer {\n  margin-top: var(--ds-space-4);\n}\n\n.rt-cards__pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: var(--ds-space-4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
